import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram, Clock } from 'lucide-react';

export const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-emerald-950 to-gray-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* About */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="h-20 w-20 rounded-full overflow-hidden shadow-xl">
                <img 
                  src="https://customer-assets.emergentagent.com/job_ems-lyon-sud/artifacts/86j81t7o_IMG_2591.jpg" 
                  alt="The Hidden Garden Logo" 
                  className="h-full w-full object-cover scale-110"
                  style={{ objectPosition: 'center' }}
                />
              </div>
              <div>
                <div className="text-lg font-bold tracking-wide text-white">
                  THE HIDDEN GARDEN
                </div>
                <div className="text-sm text-yellow-500 font-light tracking-wider">
                  CENTRE WELLNESS & EMS
                </div>
              </div>
            </div>
            <p className="text-sm text-gray-300 leading-relaxed">
              Votre centre de wellness esthétique et EMS à Oullins. 
              Transformation du corps et soins experts dans un espace privé et haut de gamme.
            </p>
          </div>

          {/* Navigation Rapide */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-yellow-500">Navigation</h3>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('hero')}
                  className="text-sm text-gray-300 hover:text-emerald-400 transition-colors duration-300"
                >
                  Accueil
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('expertises')}
                  className="text-sm text-gray-300 hover:text-emerald-400 transition-colors duration-300"
                >
                  Nos Expertises
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('tarifs')}
                  className="text-sm text-gray-300 hover:text-emerald-400 transition-colors duration-300"
                >
                  Tarifs
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('faq')}
                  className="text-sm text-gray-300 hover:text-emerald-400 transition-colors duration-300"
                >
                  FAQ
                </button>
              </li>
              <li>
                <Link 
                  to="/cgv"
                  className="text-sm text-gray-300 hover:text-emerald-400 transition-colors duration-300"
                >
                  Conditions Générales
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-yellow-500">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-emerald-400 flex-shrink-0 mt-0.5" />
                <span className="text-sm text-gray-300">
                  8 Boulevard Émile Zola<br />69600 Oullins
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-emerald-400 flex-shrink-0" />
                <a 
                  href="tel:0659839111"
                  className="text-sm text-gray-300 hover:text-emerald-400 transition-colors duration-300"
                >
                  06 59 83 91 11
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-emerald-400 flex-shrink-0" />
                <a 
                  href="mailto:thg.ems.bienetre@gmail.com"
                  className="text-sm text-gray-300 hover:text-emerald-400 transition-colors duration-300"
                >
                  thg.ems.bienetre@gmail.com
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Clock className="w-5 h-5 text-emerald-400 flex-shrink-0" />
                <span className="text-sm text-gray-300">
                  Sur rendez-vous uniquement
                </span>
              </li>
            </ul>
          </div>

          {/* Social & CTA */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-yellow-500">Suivez-nous</h3>
            <div className="flex items-center space-x-4 mb-6">
              <a 
                href="https://www.instagram.com/hiddengarden.ems?igsh=MWp4OHNidTZzbGo3MQ%3D%3D&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-emerald-700 hover:bg-emerald-600 p-3 rounded-full transition-all duration-300 hover:scale-110"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
            <a
              href="https://wa.me/33659839111"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-yellow-500 hover:bg-yellow-600 text-gray-900 px-6 py-3 rounded-full font-semibold transition-all duration-300 hover:shadow-lg hover:scale-105 text-sm"
            >
              Réserver Maintenant
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © 2025 The Hidden Garden EMS. Tous droits réservés.
            </p>
            <p className="text-sm text-gray-400">
              Centre Wellness Esthétique & EMS à Oullins - Lyon Sud
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
